import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import LoadingComponent from '../layout/LoadingComponent';
import RefDataContent from './RefDataContent';

export default observer(function RefDataPage() {
    const { username } = useParams<{ username: string }>();
    const { profileStore } = useStore();
    const { loadingProfile, loadProfile, profile, setActiveTab } = profileStore;

    useEffect(() => {
        if (username)
            loadProfile(username);
        return () => {
            setActiveTab(0);
        }
    }, [loadProfile, username, setActiveTab])

    if (loadingProfile) return <LoadingComponent content='Loading reference data...' />

    return (
        <Grid>
            <Grid.Column width={16}>
                {profile &&
                    <>
                        <RefDataContent />
                    </>}
            </Grid.Column>
        </Grid>
    )
})